var active = 0;

$(document).on("click", "#start-survey", function (e) {
    e.preventDefault();
    $(".startSurvey").hide();
    $(".questionContainer").show();
    $("#previous-btn").attr("disabled", true);
});

$(document).ready(function () {
    $('.tip').each(function () {
        $(this).tooltip(
            {
                html: true,
                title: $('#' + $(this).data('tip')).html()
            });
    });
});

$(document).on("keyup", "#otherquestion01", function () {
    $(this).parent().find(".lengthCount").text(
        `${$(this).val().length} / ${$(this).data('maxlength')}  characters`);
});
$(document).on("keyup", "#otherquestion02", function () {
    $(this).parent().find(".lengthCount").text(
        `${$(this).val().length} / ${$(this).data('maxlength')}  characters`);
});
$(document).on("keyup", "#otherquestion03", function () {
    $(this).parent().find(".lengthCount").text(
        `${$(this).val().length} / ${$(this).data('maxlength')}  characters`);
});

function validateEmail($email) {

    $emailVal = $("#" + $email).val();
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var flag = emailReg.test($emailVal);
    if (!flag) {
        $("#" + $email + "error").text("Invalid Email");
    }
    return flag;
}
function validatePhone($phone) {
    var phoneVal = $("#" + $phone).val();
    console.log(phoneVal);

    var flag = phoneVal.length === 10 && !isNaN(phoneVal); // Ensure it's exactly 10 digits and numeric
    if (!flag) {
        $("#" + $phone + "error").text("Invalid Phone Number");
    }
    console.log(flag);

    return flag;
}


function checkRequired(value) {
    var inputVal = $("#" + value).val();

    if (inputVal === "" || inputVal === null) {
        $("#" + value + "error").text("Required");
        return false;
    }

    if (value === "name" && inputVal.length > 250) {
        $("#" + value + "error").text("The name field not more than 250 characters");
        return false;
    }

    $("#" + value + "error").text("");
    return true;
}

function checkRequiredWithName(value) {
    if (($('[name="' + value + '"]:checked').val() == "") || ($('[name="' + value + '"]:checked').val() == null)) {
        $("#" + value + "error").text("Required");
        return false;
    }
    else {
        return true;
    }
}
function checkRequiredWithMultipleName(value, value1, errorID) {
    if (($('[name="' + value + '"]:checked').val() == "") || ($('[name="' + value + '"]:checked').val() == null) || ($('[name="' + value1 + '"]:checked').val() == "") || ($('[name="' + value1 + '"]:checked').val() == null)) {
        $("#" + errorID + "error").text("Required");
        return false;
    }
    else {
        return true;
    }
}

function checkRequiredCheckboxWithName(value) {
    if ($('input[type="checkbox"][name^="' + value + '"]:checked').length === 0) {
        $("#" + value.replace("[]", "") + "error").text("Please select at least one option.");
        return false;
    }
    else {
        return true;
    }
}

function checkRequiredIsAgreeName(value) {
    if (!$('input[type="checkbox"][name="' + value + '"]:checked').length) {
        $("#" + value + "error").text("Required.");
        return false;
    } else {
        $("#" + value + "error").text("");
        return true;
    }
}


function changeDot() {
    $(".dottedNav span").removeClass("active");
    $(".dottedNav span:eq(" + active + ")").addClass("active");
}


function nextPage(activeNo) {
    $('[data-index="' + activeNo + '"]').hide();
    $('[data-index="' + (activeNo + 1) + '"]').show();
    active++;
    changeDot();
    updateButtonStates();
    window.scrollTo({ top: 0, behavior: "smooth" });
}

// $(document).on("click", "#previous-btn", function (e) {
//     e.preventDefault();
//     $('[data-index="'+active+'"]').hide();
//     $('[data-index="'+(active - 1)+'"]').show();
//     active--;
//     if (!active) 
//     {
//         $("#previous-btn").attr("disabled", true);
//     }
//     changeDot();
// });

$(document).on("click", "#previous-btn", function (e) {
    e.preventDefault();
    $("#next-btn").text("Next");
    if (active > 0) {
        $('[data-index="' + active + '"]').hide();
        active--;
        $('[data-index="' + active + '"]').show();
        changeDot();

        // Update the "Previous" button state based on active page
        updateButtonStates();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
});

function updateButtonStates() {
    if (active === 0) {
        $("#previous-btn").attr("disabled", true);  // Disable "Previous" on the first page
    } else {
        $("#previous-btn").removeAttr("disabled");  // Enable "Previous" on other pages
    }

    // You can also disable "Next" on the last page if needed
    // if (active >= totalPages) {
    //     $("#next-btn").attr("disabled", true);
    // } else {
    //     $("#next-btn").removeAttr("disabled");
    // }
}


$(document).on("change", "input[type='checkbox']", function (e) {
    if ($(this).closest(".multipleSelection").find("input[type='checkbox'][value='Other']").length && ($(this).closest(".multipleSelection").find("input[type='checkbox'][value='Other']:checked").length)) {
        $(this).closest(".multipleSelection").find("textarea").show();
    }
    else {
        $(this).closest(".multipleSelection").find("textarea").hide();
    }
});

$(document).on("change", "#experience_year", function (e) {
    if ($(this).val() == "10+") {
        $("#experience_month").val("0");
        $("#experience_month").attr("disabled", true);
    }
    else {
        $("#experience_month").attr("disabled", false);
    }
});

$(document).on("change", "input[type='radio']", function (e) {
    if ($(this).val() == "Other") {
        $(this).closest(".singleSelection").find("textarea").show();
    }
    else {
        $(this).closest(".singleSelection").find("textarea").hide();
    }
});

function checkOtherFunction(value) {
    if ($("[name^='" + value + "']").closest(".singleSelection").find("input[type='radio'][value='Other']:checked").length) {
        // var otherValue = checkRequired("other"+ value.replace("[]", ""));
        var otherValue = checkRequired("other" + value);
        return otherValue;
    }
    else {
        return true;
    }
}

function checkOtherRadioFunction(value) {
    // alert($("[name^='"+value+"']:checked").val());
    if ($("[name^='" + value + "']:checked").val() == "Other") {
        // alert("other"+ value);
        var otherValue = checkRequired("other" + value);
        // alert(otherValue);
        return otherValue;
    }
    else {
        return true;
    }
}

function formSubmit() {
    $("#top-cio-form").trigger("submit");
}

$(document).on("submit", "#top-cio-form", async function (e) {
    e.preventDefault();
    if (!currentURL.includes("127.0.0.1") && !currentURL.includes("192.168.1") && !currentURL.includes("localhost")) {
        var recaptchaResponse = grecaptcha.getResponse();
        if (recaptchaResponse === "") {
            $('#g-recaptcha-responseerror').text('Required');
            return;
        }
        else {
            $('#g-recaptcha-responseerror').text('');
        }
    }

    var data = await ajaxDynamicMethod(backendURL + "/api/fourm/top-cio-request", $(this).attr('method'), generateFormData(
        this));
    if (data.success) {
        $(".questionContainer").hide();
        $(".thankyouContainer").show();
    }
});

$("#fileInput").on("change", function () {
    let files = this.files;
    if (files.length > 3) {
        $("#fileCountMessage").text("You can only select up to 3 files.");
        this.value = ""; // Reset file input
    } else {
        $("#fileCountMessage").text(""); // Clear message if valid
    }
});

$(document).on("change", "#documents", function () {
    let files = this.files;
    let maxFiles = 3;
    let maxSize = 3 * 1024 * 1024; // 3MB in bytes
    let errorMessage = "";

    if (files.length > maxFiles) {
        errorMessage = "You can only select up to 3 files.";
    } else {
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > maxSize) {
                errorMessage = "Each file must be less than 3MB.";
                break; // Stop checking if any file is too large
            }
        }
    }

    if (errorMessage) {
        $("#documentserror").text(errorMessage);
        this.value = ""; // Reset file input
    } else {
        $("#documentserror").text(""); // Clear message if valid
    }
});

$(document).on("change", "#profile", function () {
    let file = this.files[0]; // Get the selected file
    let maxSize = 3 * 1024 * 1024; // 3MB in bytes

    if (file && file.size > maxSize) {
        $("#profileerror").text("File must be less than 3MB.");
        this.value = ""; // Reset input
    } else {
        $("#profileerror").text(""); // Clear message if valid
    }
});


$(document).on("click", "#next-btn", function (e) {
    e.preventDefault();
    $(".error-text").text("");
    // if (active != 0) 
    // {
    //     $("#previous-btn").attr("disabled", false);
    // }
    // else
    // {
    //     $("#previous-btn").removeAttr("disabled");
    // }
    if (active > 0) {
        $("#previous-btn").removeAttr("disabled");
    } else {
        $("#previous-btn").attr("disabled", true);
    }
    $("#next-btn").text("Next");
    switch (active) {
        case 0:
            var name = checkRequired("name");
            var designation = checkRequired("designation");
            var organization = checkRequired("organization");
            var experience = checkRequired("experience");
            var phone = checkRequired("phone");
            var linkedin = checkRequired("linkedin");
            var profile = checkRequired("profile");
            var email = checkRequired("email");
            var experience_year = checkRequired("experience_year");
            var experience_month = checkRequired("experience_month");

            if (!experience_year || !experience_month) {
                $("#experienceerror").text("Required");
            }
            else {
                $("#experienceerror").text("");
            }


            if (email) {
                email = validateEmail("email");
            }
            if (phone) {
                phone = validatePhone("phone");
            }
            if (name && email && designation && organization && experience && phone && linkedin && profile) {
                nextPage(active);
            }
            break;
        case 1:
            var question01 = checkRequired("otherquestion01");
            var initiatives = checkRequiredCheckboxWithName("initiatives[]");
            var question03 = checkRequired("otherquestion03");

            if (question01 && initiatives && question03) {
                nextPage(active);
            }
            break;
        case 2:
            nextPage(active);
            $("#next-btn").text("Submit");
            break;
        case 3:
            var is_terms = checkRequiredIsAgreeName("is_terms");

            if (is_terms) {
                formSubmit();
            }
            break;
        default:
            break;
    }
});

